<template>
  <div>
    <label :for="id" class="block text-xs font-semibold text-gray-600 dark:text-gray-300 mb-1">{{ label }}</label>
    <textarea v-if="type === 'textarea'" :id="id" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"
      :rows="rows" :maxlength="maxlength" :placeholder="placeholder" :class="INPUT + ' py-2 resize-y min-h-[4.5rem]'"></textarea>
    <select v-else-if="type === 'select'" :id="id" :value="modelValue" @change="$emit('update:modelValue', $event.target.value)" :class="INPUT + ' h-9'">
      <option value="">{{ placeholder || 'Select' }}</option>
      <option v-for="option in choices" :key="option" :value="option">{{ option }}</option>
    </select>
    <input v-else :id="id" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"
      :type="type" :maxlength="maxlength" :placeholder="placeholder" autocomplete="off" :class="INPUT + ' h-9'">
    <p v-if="counter" class="text-[11px] text-gray-400 dark:text-gray-500 text-right mt-0.5 tabular-nums">{{ (modelValue || '').length }} / {{ maxlength }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const INPUT = 'w-full px-3 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-[#0d1117] text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:border-blue-400'

const props = defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, required: true },
  type: { type: String, default: 'text' }, // text | textarea | select | email | tel | url
  options: { type: Array, default: () => [] }, // the choices of a select
  rows: { type: Number, default: 3 },
  maxlength: { type: Number, default: 200 },
  placeholder: { type: String, default: '' },
  counter: { type: Boolean, default: false },
})
defineEmits(['update:modelValue'])

// A value saved earlier that is not one of the choices (it was typed freely once) is kept as a choice.
const choices = computed(() => (props.modelValue && !props.options.includes(props.modelValue) ? [...props.options, props.modelValue] : props.options))

const id = `field-${Math.random().toString(36).slice(2, 9)}`
</script>
